import { render, staticRenderFns } from "./SortByMenu.vue?vue&type=template&id=600b79ec&scoped=true&"
import script from "./SortByMenu.vue?vue&type=script&lang=js&"
export * from "./SortByMenu.vue?vue&type=script&lang=js&"
import style0 from "./SortByMenu.vue?vue&type=style&index=0&id=600b79ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b79ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600b79ec')) {
      api.createRecord('600b79ec', component.options)
    } else {
      api.reload('600b79ec', component.options)
    }
    module.hot.accept("./SortByMenu.vue?vue&type=template&id=600b79ec&scoped=true&", function () {
      api.rerender('600b79ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/SortByMenu.vue"
export default component.exports